import { IQuizFormOption, IRangeValue } from '../../../types/quiz';

export const rangeToValue = (range: IRangeValue | undefined | null) => {
  if (!range) {
    return undefined;
  }

  return `${Number(range.gte)}/${Number(range.lte)}`;
};

export const valueToRange = (value: string) => {
  const [gte, lte] = value.split('/');

  const gteValue = gte ? Number(gte) : undefined;
  const lteValue = lte ? Number(lte) : undefined;

  return { gte: gteValue, lte: lteValue };
};

export const prepareOptions = (options: IQuizFormOption[]) => {
  return options.map((option: IQuizFormOption) => {
    const value = option.value as IRangeValue;

    return {
      value: rangeToValue(value),
      label: option.text,
      dataTestId: 'QuizFormChipOption',
    };
  });
};
